import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "formatLabel"})
export class FormatLabelPipe implements PipeTransform {
  transform(label: string): string {
      return label.split(" ").shift();
  }
}
